var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Speaker = function Speaker(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 18 20' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M16.75 6.1h.75a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5zm-15 2.2c0-.55.15-.8.7-.8h2.499c.55 0 1.305-.332 1.678-.736L10.75 2.3c.373-.404 1.573-.23 1.69-.23.116 0 .31.047.31.597v14.667c0 .549-.194.596-.31.596-.117 0-1.318.174-1.69-.23l-4.123-4.465c-.373-.404-1.128-.735-1.678-.735h-2.5c-.55 0-.699-.252-.699-.8V8.3zM11.424 0c-.55 0-1.305.331-1.678.735L5.728 5.097c-.373.405-1.128.736-1.678.736H1.1C.55 5.833 0 6.38 0 6.93v6.14c0 .549.55 1.097 1.1 1.097h2.95c.55 0 1.305.331 1.678.735l4.018 4.362c.373.404 1.128.736 1.678.736h2.075c.549 0 1-.451 1-1V1c0-.55-.451-1-1-1h-2.075z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Speaker;
//# sourceMappingURL=Speaker.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Speaker.js